uniform vec2 resolution;
uniform float time;
varying vec2 vUv;

float PI = 3.141592653589793;

mat2 rotate2d(float _angle){
    return mat2(cos(_angle),-sin(_angle),
                sin(_angle),cos(_angle));
}

// x: rotation, counter clock wise
// y: distance from center (1==half height)
vec2 toPolarUV(vec2 uv, vec2 resolution) {
    vec2 p =  uv;
    p -= 0.5;
    p.x = p.x * (resolution.x / resolution.y);

    float pixelAngle = atan(p.x, p.y);
    float pixelDistance = length(p) * 2.0;

    return vec2(pixelAngle / 6.28318530717958623199592693708 + 0.5, pixelDistance);
}

vec3 interpolate6Colors(float v, vec3 color1, vec3 color2, vec3 color3, vec3 color4, vec3 color5, vec3 color6) {
    vec3 result;

    // Normalize v to be between 0 and 1
    v = clamp(v, 0.0, 1.0);

    if(v < 0.2) {
        // Interpolate between color1 and color2
        result = mix(color1, color2, v * 5.0);
    } else if(v < 0.4) {
        // Interpolate between color2 and color3
        result = mix(color2, color3, (v - 0.2) * 5.0);
    } else if(v < 0.6) {
        // Interpolate between color3 and color4
        result = mix(color3, color4, (v - 0.4) * 5.0);
    } else if(v < 0.8) {
        // Interpolate between color4 and color5
        result = mix(color4, color5, (v - 0.6) * 5.0);
    } else {
        // Interpolate between color5 and color6
        result = mix(color5, color6, (v - 0.8) * 5.0);
    }

    return result;
}

void main() {

    vec2 uv = vUv;

    vec2 polarUV = toPolarUV(uv, resolution);

    polarUV.y += time * 0.0001;


    // gl_FragColor = vec4(polarUV.x, polarUV.y, 0.0, 1.0);

    float width = 100.0 + (80.0 * sin(time * 0.001));
    float smoothingFactor = 0.001;
    float halfWidth = width/2.0;

    float rhythm = smoothstep(-smoothingFactor, 0.0, sin(polarUV.y * ((resolution.y/width/2.0) * PI)));
    float rhythmStepped = step(0.0, sin(polarUV.y * ((resolution.y/width/2.0) * PI)));

    //polarUV.y -= time * (-20.0 * rhythmStepped) * 0.0001;
    float t = mix(time, -time, rhythmStepped);

    polarUV.x *= 2.0;
    polarUV.x += sin(polarUV.y * 2.0);
    polarUV.x += t * 0.0001;
    polarUV.x = mix(polarUV.x, polarUV.x * -1.0, step(0.5, rhythm));
    //polarUV.x += (time * 0.0001);
    //polarUV.x += rhythmStepped;

    polarUV.x += floor(polarUV.x) * 0.266;

    vec3 aColor = interpolate6Colors(
        mod(polarUV.x, 1.0),
        vec3(0.96,0.74,0.23),
        vec3(0.56,0.63,0.72),
        vec3(0.64,0.19,0.16),
        vec3(0.74, 0.31, 0.31),
        vec3(0.29, 0.48, 0.47),
        vec3(0.96,0.74,0.23)
    );

    vec3 bColor = interpolate6Colors(
        mod(1.0 - polarUV.x - 0.123, 1.0),
        vec3(0.18,0.36,0.75),
        vec3(0.96,0.29,0.15),
        vec3(0.84, 0.85, 0.59),
        vec3(0.74,0.33,0.16),
        vec3(0.69,0.15,0.21),
        vec3(0.18,0.36,0.75)
    );



    vec3 outColor =  mix(aColor, bColor, rhythmStepped);

    gl_FragColor = vec4(outColor, 1.0);

}